import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { ProjectShowroomInfo } from '../models/investors';
import { updateShowroomInfoEndpoint } from '../services/showroomInfoService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

const useProjectShowroomInfo = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const [apiErrors, setApiErrors] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const doUpdateShowroomInfo = async (
    projectId: string,
    payload: Omit<ProjectShowroomInfo, 'image'>,
  ): Promise<number> => {
    const { data, status } = await callEndpoint(
      updateShowroomInfoEndpoint(projectId, payload, token),
    );
    const response = fetchResponseAdapter(data);

    if (status !== 200) setApiErrors(response.message);

    return status;
  };

  return {
    apiErrors,
    doUpdateShowroomInfo,
  };
};

export default useProjectShowroomInfo;
